import { useAgenticLogicRuleVersionDetail } from "@src/api/agentic-logic/get-agentic-logic-rule-version-detail";
import { type WorkspaceVersionDetailResult } from "@src/features/agenticCodegen/workspace/components/VersionHistory/VersionCodeDetail";

/**
 * The Agentic Logic binding of the shell's version-detail read. Projects the
 * rule DTO onto the shared shape; there are no domain-only summary rows to add,
 * unlike shipping's fallback policy.
 */
export const useAgenticVersionDetail = (
  ruleId: string | undefined,
  version: number
): WorkspaceVersionDetailResult => {
  const query = useAgenticLogicRuleVersionDetail(ruleId, version);
  const detail = query.data?.detail;

  return {
    detail: detail
      ? {
          version: {
            id: detail.version.id,
            version: detail.version.version,
            status: detail.version.status,
            publishedAtTs: detail.version.publishedAtTs,
            publishedByUserId: detail.version.publishedByUserId,
            // The DTO carries no expanded user record.
            publishedByUser: null,
            notes: detail.version.notes,
            title: detail.version.title,
            origin: detail.version.origin,
            dependencyLockHash: detail.version.dependencyLockHash,
          },
          // The detail DTO carries a name→version lock map rather than the
          // declared dependency list, so project it back to the shared shape.
          dependencies: Object.entries(detail.dependencyLock).map(
            ([name, lockedVersion]) => ({ name, version: lockedVersion })
          ),
          sourceUrl: detail.sourceUrl,
          // Agentic Logic publishes no generated suite artifact.
          generatedTestsUrl: null,
          userTestsUrl: detail.userTestsUrl,
        }
      : undefined,
    isLoading: query.isLoading,
    isError: query.isError,
  };
};
